import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataDiscountCodes from "@/data/AdminPanel/DataDiscountCodes";
import sweetalert from "sweetalert";
import { Getter } from "vuex-class";
import EUserEnum from "@/struct/user/EUserEnum";
import ApiShopDiscountCodes from "@/api/ApiShopDiscountCodes";
import dayjs from "dayjs";
let DiscountCodes = class DiscountCodes extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataDiscountCodes.Breadcrumbs;
        this.TableHeaders = DataDiscountCodes.TableHeaders;
        this.TableItems = [];
    }
    FormatDate(date) {
        if (!date) {
            return "";
        }
        return dayjs.tz(date, "Europe/Rome").format("DD-MM-YYYY");
    }
    async GetDiscountCodes() {
        try {
            this.TableItems = await ApiShopDiscountCodes.GetDiscountCodes(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    GetStatus(discountCode) {
        if (discountCode.expires_at && new Date(discountCode.expires_at) < new Date()) {
            return "Expired";
        }
        return discountCode.active ? "Active" : "Inactive";
    }
    CanAdminAccess() {
        return this.GetCurrentSessionUser != undefined && this.GetCurrentSessionUser.system_role == EUserEnum.SystemRole.SuperAdmin;
    }
    DeleteDiscountCode(discount_code_uuid) {
        sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("discount_codes.accept_delete"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        }).then(async (isConfirm) => {
            if (isConfirm == true) {
                const response = await ApiShopDiscountCodes.DeleteDiscountCode(ApiEnter.CurrentSessionUUID, discount_code_uuid);
                if (typeof response == "boolean") {
                    await sweetalert({
                        title: this.$t("general.success"),
                        text: this.$t("general.success_deleted"),
                        icon: "success",
                    });
                    await this.GetDiscountCodes();
                }
                else {
                    await sweetalert({
                        title: this.$t("general.error"),
                        text: this.$t("general.request_error"),
                        icon: "info",
                    });
                }
            }
        });
    }
    mounted() {
        this.GetDiscountCodes();
    }
};
__decorate([
    Getter("getCurrentSessionUser")
], DiscountCodes.prototype, "GetCurrentSessionUser", void 0);
DiscountCodes = __decorate([
    Component({
        methods: { dayjs },
        components: { StandartTemplate, PageHeader },
    })
], DiscountCodes);
export default DiscountCodes;
